import { QlickupActions, useQlickupAPI } from "../APICall";

//https://ordata.link1studios.com/CMS/V1/GET/leads.php?userid=10&token=ad88460c744051812ec6da3b25fe69f67afc6d7cc4aa36085a121da2a9edd7a4&businessid=19&action=getSocialLeads

export const useAutoLeads = () => {
  const { QlickUpAPI } = useQlickupAPI();

  const getConnectionLink = async (businessid: number) => {
    try {
      const response = await QlickUpAPI(
        businessid.toString(),
        "getSocialLeads",
        null,
        "leads",
        QlickupActions.GET
      );
      if (response.success) {
        return response.integration.fb_connect_url as string;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error fetching connection link:", error);
      return null;
    }
  };

  return {
    getConnectionLink,
  };
};
